<div
    class="content"
    [ngClass]="{'callReg-Normal' : DisplayMode == 1, 'callReg-Compact': DisplayMode == 2, 'callReg-Expanded': DisplayMode == 3}"
>
    <div class="row flex-nowrap">
        <div
            class="col-auto registerViewType pointer flex-fill align-items-center"
            [ngClass]="(DisplayMode == 2 ? 'd-flex' : '')"
            [class.registerViewCollapsed]="DisplayMode == 2 && !ShowQuickJob"
            [hidden]="DisplayMode != 2"
            (click)="ShowQuickJob = !ShowQuickJob"
            title="{{'NAV.NAV_NEW_JOB' | translate}}"
        >
            <i class="ksv-icon-bolt fa-lg"></i>
        </div>

        <div
            class="col-auto"
            [hidden]="DisplayMode == 2 && ShowQuickJob == false"
        >
            <div class="standardForm callRegister">
                <form class="" (ngSubmit)="FormSubmit()" name="frm">
                    <div [hidden]="DisplayMode == 2">
                        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
                    </div>

                    <div class="row">
                        <div
                            class="col"
                            [ngClass]="DisplayMode == 2 ? 'd-flex flex-row': ''"
                        >
                            <div
                                class="row"
                                [ngClass]="DisplayMode == 2 ? 'entryCell': ''"
                            >
                                <div
                                    class="col"
                                    [ngClass]="DisplayMode == 2 ? 'd-flex flex-row regContainer': ''"
                                >
                                    <div
                                        class="row form-group align-items-center entryCell entryCell-Prop"
                                        *ngIf="masterService.LoggedInUserData.Properties.length > 1"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-property frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <select
                                                class="custom-select"
                                                id="PropertyId"
                                                [(ngModel)]="Model.PropertyId"
                                                name="PropertyId"
                                                [disabled]="SaveModel.length > 0"
                                                (change)="onPropertyChange()"
                                            >
                                                <option
                                                    *ngFor="let row of lstProperties"
                                                    [value]="row.PropertyId"
                                                >
                                                    {{row.PropertyName}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group entryCell"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            &nbsp;
                                        </div>
                                        <div class="col-auto entryFld">
                                            <div
                                                class="custom-control custom-radio custom-control-inline"
                                            >
                                                <input
                                                    type="radio"
                                                    name="IsGuestCall"
                                                    id="IsGuestCall_1"
                                                    class="custom-control-input"
                                                    [value]="true"
                                                    [(ngModel)]="Model.IsGuestCall"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="IsGuestCall_1"
                                                    translate
                                                    >LBL.REQ_BY_GUEST</label
                                                >
                                            </div>
                                            <div
                                                class="custom-control custom-radio custom-control-inline"
                                            >
                                                <input
                                                    type="radio"
                                                    name="IsGuestCall"
                                                    id="IsGuestCall_2"
                                                    class="custom-control-input"
                                                    [value]="false"
                                                    [(ngModel)]="Model.IsGuestCall"
                                                    (change)="StaffRequest()"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="IsGuestCall_2"
                                                    translate
                                                    >LBL.REQ_BY_STAFF</label
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell entryCell-Location"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_location frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select
                                                [items]="lstLocations"
                                                class="req_place"
                                                bindLabel="Description"
                                                bindValue="Id"
                                                placeholder="{{'PH.PH_LOCATION' | translate}}"
                                                name="LocationId"
                                                (change)="onLocationChange($event);"
                                                [dropdownPosition]="DisplayMode == 2 ? 'top': 'auto'"
                                                [(ngModel)]="Model.LocationId"
                                                #LocationId="ngModel"
                                                #cmbLocations
                                            >
                                            </ng-select>
                                        </div>
                                        <!-- DEV-20345: split-screen location-history dialog trigger,
                                             placed beside the Location dropdown. Hidden on desktop via CSS. -->
                                        <div
                                            class="col-auto locationHistoryTrigger"
                                            *ngIf="DisplayMode != 2 && (Model.LocationId || Model.RequestedByGuestId || SaveModel.length > 0)"
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-outline-primary"
                                                (click)="openLocationHistory()"
                                                title="{{'LBL.LOCATION_HISTORY' | translate}}"
                                            >
                                                <i class="icon-kc-icon_location"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2 || Model.IsGuestCall == false"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_guest frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select
                                                [items]="lstGuest"
                                                class="req_place"
                                                (change)="onGuestChange($event)"
                                                bindLabel="FullName"
                                                bindValue="GuestId"
                                                placeholder="{{'PH.PH_GUEST' | translate}}"
                                                name="RequestedByGuestId"
                                                [(ngModel)]="Model.RequestedByGuestId"
                                                #cmbGuests
                                            >
                                            </ng-select>
                                        </div>
                                        <!--<div class="col-auto">
                                            <button type="button" class="btn btn-secondary" (click)="RefreshGuest()"><i class="fas fa-sync-alt"></i></button>
                                        </div>-->
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_category frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select
                                                [items]="lstCallCategories"
                                                class=""
                                                bindLabel="Description"
                                                bindValue="Id"
                                                placeholder="{{'PH.PH_CATEGORY' | translate}}"
                                                name="CategoryId"
                                                (change)="onCategoryChange()"
                                                [(ngModel)]="Model.CategoryId"
                                                #cmbCallCategories
                                            >
                                                <ng-template
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        class="d-flex p-1 flex-row justify-content-between align-items-center"
                                                    >
                                                        <span
                                                            >{{ item.Description
                                                            }}</span
                                                        >
                                                        <i
                                                            *ngIf="item.IsKMTCategory"
                                                            class="text-danger kmt-icons kmt-icon-construction"
                                                        ></i>
                                                        <i
                                                        *ngIf="(item?.IsKMTCategory === false || item?.IsKMTCategory === 0)"
                                                        class="kmt-icons kmt-icon-construction"
                                                    ></i>


                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell entryCell-Description"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_info frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select
                                                [items]="lstCallDescriptions"
                                                class="req_place"
                                                bindLabel="Description"
                                                bindValue="Id"
                                                placeholder="{{'PH.PH_DESCR' | translate}}"
                                                [dropdownPosition]="DisplayMode == 2 ? 'top': 'auto'"
                                                name="CallDescriptionsId"
                                                [(ngModel)]="Model.CallDescriptionsId"
                                                (change)="DescriptionChanged($event)"
                                                #cmbCallDescriptions
                                            >
                                                <ng-template
                                                    ng-optgroup-tmp
                                                    let-item="item"
                                                >
                                                    <div class="ddGroup">
                                                        <span
                                                            *ngIf="item.IsQuickCall"
                                                            translate
                                                            >LBL.QUICK</span
                                                        ><span
                                                            *ngIf="item.IsQuickCall == false"
                                                            translate
                                                            >LBL.ALL</span
                                                        >
                                                    </div>
                                                </ng-template>
                                                <ng-template
                                                    ng-option-tmp
                                                    let-item="item"
                                                    let-index="index"
                                                    let-search="searchTerm"
                                                >
                                                    <div
                                                        class="d-flex p-1 flex-row justify-content-between align-items-center"
                                                    >

                                                        <span
                                                            >{{ item.Description
                                                            }}</span
                                                        >
                                                        <div class="flex gap-4">
                                                        <i
                                                            *ngIf="item.IsduplicateAllowed"
                                                            class="text-info fa fa-clone"
                                                        ></i>
                                                        <i
                                                            *ngIf="item.IsFromKMTCategory"
                                                            class="text-danger kmt-icons kmt-icon-construction"
                                                        ></i>
                                                        <i
                                                        *ngIf="item.IsFromKMTCategory === false"
                                                        class="kmt-icons kmt-icon-construction"
                                                    ></i>
                                                </div>
                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div
                                            class="col-auto"
                                            [hidden]="DisplayMode == 2"
                                        >
                                            <a
                                                *ngIf="this.Model.RequestedByGuestId != null && showPrefIcon"
                                                (click)="AddPreference()"
                                                title="{{'BTN.BTN_ADD_PREFERENCE' | translate}}"
                                                [ngClass]="{'highlight_Color': showPrefIcon_Preset }"
                                            >
                                                <i
                                                    class="fas fa-heart fa-2x"
                                                ></i>
                                            </a>
                                        </div>
                                    </div>

                                     <div *ngIf="isFoundInventoryWithDesc && inventorySingularityEnabled"
                                        class="row form-group align-items-center entryCell entryCell-Description"
                                    >
                                        <div class="col-1 entryIcon">
                                             <img src="../../../assets/inventory-icon.png" alt="Inventory_icon" class="inventory-icon"> 
                                        </div>
                                        <div class="col entryFld quantity-wrap">
                                            <span *ngIf="isFoundInventoryWithDesc">
                                                {{isFoundInventoryWithDesc.Name}}
                                            </span>
                                            <div class="quantity-box">
                                                <div class="label-quantity">
                                                    {{"LBL.QUANTITY" | translate}}
                                                </div>
                                                <div>
                                                    <input type="number" name="DefaultQuantity" 
                                                        matInput
                                                        [(ngModel)]="isFoundInventoryWithDesc.DefaultQuantity"
                                                        class="form-control" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell entryCell-Remarks"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_remarks frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <RemarksPopupTrigger
                                                [(Model)]="Model.Remarks"
                                            >
                                                <textarea
                                                    style="resize: none"
                                                    id="Remarks"
                                                    [(ngModel)]="Model.Remarks"
                                                    [attr.rows]="DisplayMode == 2 ? '1' : '2'"
                                                    class="form-control"
                                                    placeholder="{{'PH.PH_REMARK' | translate}}"
                                                    name="Remarks"
                                                ></textarea>
                                            </RemarksPopupTrigger>
                                            <a
                                                [hidden]="DisplayMode == 2"
                                                *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.CallAttachment_Register)"
                                                (click)="callAttachment.Open(Model)"
                                                class="border rounded-circle attachment"
                                                href="javascript:{}"
                                                title="{{'TITLE.TITLE_ADD_ATTACHMENTS' | translate}}"
                                            >
                                                <i class="fas fa-paperclip"></i>
                                                <span
                                                    *ngIf="Model.AttachmentCount > 0"
                                                    >&nbsp;{{Model.AttachmentCount}}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="col-auto"
                                            [hidden]="DisplayMode == 2"
                                        >
                                            <a
                                                (click)="AddMultiple()"
                                                title="{{'TITLE.TITLE_ADD_MULTIPLE' | translate}}"
                                            >
                                                <i
                                                    class="fas fa-plus-circle fa-2x"
                                                ></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-html-icons_priority frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <select
                                                class="custom-select"
                                                [ngStyle]="{'color' : Model.Priority ? null : '#a9a3a3'}"
                                                id="Priority"
                                                [(ngModel)]="Model.Priority"
                                                name="Priority"
                                                [disabled]="disabledPriority"
                                            >
                                                <option
                                                    [ngValue]="null"
                                                    disabled
                                                    selected
                                                    hidden
                                                >
                                                    <span
                                                        translate
                                                        class="text-muted"
                                                        >LBL.PRIORITY</span
                                                    >
                                                </option>
                                                <option
                                                    *ngFor="let row of lstPriority"
                                                    style="color: #495057"
                                                    [value]="row.Id"
                                                >
                                                    {{row.Name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_staff frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <select
                                                class="custom-select"
                                                id="IsAutoAssign"
                                                [(ngModel)]="Model.IsAutoAssign"
                                                name="IsAutoAssign"
                                                (change)="onAutoAssign()"
                                                [disabled]="!CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.ManualAssign)"
                                            >
                                                <option
                                                    [ngValue]="true"
                                                    translate
                                                >
                                                    ENTITIES.ENTITIES_AUTOMATIC
                                                </option>
                                                <option
                                                    [ngValue]="false"
                                                    translate
                                                >
                                                    ENTITIES.ENTITIES_MANUAL
                                                </option>
                                            </select>
                                            <div
                                                class="mt-2"
                                                *ngIf="Model.AssignedTo"
                                            >
                                                <b>
                                                    <span translate
                                                        >LBL.ASSIGN_TO</span
                                                    >:
                                                </b>
                                                {{AssignTo.Name}}
                                                <a
                                                    (click)="onAutoAssign()"
                                                    href="javascript:{}"
                                                    class="ml-3"
                                                >
                                                    <span translate
                                                        >LBL.CHANGE</span
                                                    >
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2 || IsKMTCategorySelected"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_close frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <div class="row">
                                                <div class="col">
                                                    <div
                                                        class="custom-control custom-radio custom-control-inline"
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="CurrentStatus"
                                                            id="CurrentStatus_1"
                                                            class="custom-control-input"
                                                            [value]="'OPN'"
                                                            [(ngModel)]="Model.CurrentStatus"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="CurrentStatus_1"
                                                            translate
                                                            >LBL.OPEN</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-radio custom-control-inline"
                                                        *ngIf="Model.Priority != 4"
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="CurrentStatus"
                                                            id="CurrentStatus_2"
                                                            class="custom-control-input"
                                                            [value]="'CLS'"
                                                            [(ngModel)]="Model.CurrentStatus"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="CurrentStatus_2"
                                                            translate
                                                            >LBL.CLOSED</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-radio custom-control-inline"
                                                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.CallPark) && Model.Priority != 4"
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="CurrentStatus"
                                                            id="CurrentStatus_3"
                                                            class="custom-control-input"
                                                            [value]="'PRK'"
                                                            [(ngModel)]="Model.CurrentStatus"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="CurrentStatus_3"
                                                            translate
                                                            >LBL.PARK</label
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="row form-group entryCell"
                                        *ngIf="Model.CurrentStatus != 'OPN'"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            &nbsp;
                                        </div>
                                        <div class="col entryFld">
                                            <div
                                                class="row"
                                                *ngIf="Model.CurrentStatus == 'CLS'"
                                            >
                                                <div class="col">
                                                    <select
                                                        class="custom-select"
                                                        id="ClosedReasonCode_Close"
                                                        [(ngModel)]="Model.ClosedReasonCode_Close"
                                                        name="ClosedReasonCode_Close"
                                                        [disabled]="!Model.IsClosed"
                                                    >
                                                        <option
                                                            [value]="0"
                                                            translate
                                                        >
                                                            CMB_DEF.CMB_DEF_SELECT_CLOSE_RASON
                                                        </option>
                                                        <option
                                                            *ngFor="let row of masterService.GetReasonTypes(Model.PropertyId, 'CLSR')"
                                                            [value]="row.ID"
                                                        >
                                                            {{row.Description}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div
                                                class="row"
                                                [hidden]="Model.CurrentStatus != 'PRK'"
                                            >
                                                <div class="col">
                                                    <ParkEntry
                                                        #parkentry
                                                        [Model]="Model"
                                                    ></ParkEntry>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="row form-group align-items-center entryCell"
                                        [hidden]="DisplayMode == 2"
                                    >
                                        <div class="col-1 entryIcon">
                                            <i
                                                class="icon-kc-icon_reporter frmIcon"
                                            ></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select
                                                [items]="lstStaff"
                                                class=""
                                                bindLabel="Name"
                                                bindValue="Id"
                                                placeholder="{{'PH.PH_REPORTED_BY' | translate}}"
                                                name="RequestedByStaffId"
                                                [(ngModel)]="Model.RequestedByStaffId"
                                                #cmbRequestByStaffId
                                            >
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="row form-group entryCell mr-0"
                                [hidden]="DisplayMode != 2"
                            >
                                <div
                                    class="col-auto pointer expandToggle d-flex align-items-center"
                                    [hidden]="DisplayMode != 2"
                                    (click)="DisplayMode = 3"
                                    title="{{'TITLE.TITLE_EXPAND' | translate}}"
                                >
                                    <i class="ksv-icon-expand fa-lg"></i>
                                </div>
                            </div>

                            <div class="row form-group btnRow entryCell-btns">
                                <div class="col-1 entryIcon">&nbsp;</div>
                                <div class="col d-flex justify-content-between">
                                    <!--<div class="row justify-content-between">-->
                                    <div class="col-auto pl-0 d-flex">
                                        <button
                                            type="submit"
                                            [disabled]="IsSubmitting"
                                            class="btn btn-primary flex-fill"
                                            translate
                                        >
                                            BTN.BTN_REGISTER
                                        </button>
                                        <button
                                            type="button"
                                            [disabled]="IsSubmitting"
                                            class="btn btn-outline-primary dangerous flex-fill"
                                            (click)="onClear()"
                                            translate
                                        >
                                            BTN.BTN_CLEAR
                                        </button>
                                        <button
                                            type="button"
                                            [disabled]="IsSubmitting"
                                            [hidden]="DisplayMode != 3"
                                            (click)="DisplayMode = 2"
                                            class="btn btn-dark"
                                            title="{{'TITLE.TITLE_COLLAPSE' | translate}}"
                                        >
                                            <i
                                                class="icon-html-icons_collapse"
                                            ></i>
                                        </button>
                                    </div>
                                    <div
                                        class="col text-right pr-0"
                                        [hidden]="DisplayMode == 2 || Model.AttachmentCount > 0"
                                        *ngIf="Model && SaveModel.length == 0 && (Model.CallDescriptionsId == null || (Model.CallDescriptionsId != null && CheckAuth_Dept_Action(Model.PropertyId, GetDeptId(), _AuthActionCodes.CallRecurrence))) && Model.Priority != 4"
                                    >
                                        <button
                                            type="button"
                                            [disabled]="IsSubmitting"
                                            class="btn btn-outline-secondary mr-0"
                                            [hidden]="Model.CurrentStatus == 'CLS' || Model.CurrentStatus == 'PRK'"
                                            (click)="onRecurrence()"
                                            translate
                                        >
                                            BTN.BTN_RECURRENCE
                                        </button>
                                    </div>
                                </div>
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>

        <!-- DEV-20345: a single in-component location-history panel. On desktop
             it renders inline as a side column. On split-screen the SAME element
             is styled (via .locationHistoryDialog + CSS) as a centered overlay
             dialog, shown only when showLocationDialog is true (toggled by the
             button beside Location). Keeping it inside this component's view
             means jobConsole_Compact.Open() binds data exactly like desktop. -->
        <div
            class="locationHistoryBackdrop"
            *ngIf="showLocationDialog"
            (click)="closeLocationHistory()"
        ></div>
        <div
            class="ml-5 col locationHistoryInline"
            [class.locationHistoryDialog]="showLocationDialog"
            [ngClass]="DisplayMode != 2 ? 'd-flex': ''"
            [hidden]="DisplayMode == 2"
        >
            <div class="locationHistoryDialogHeader" *ngIf="showLocationDialog">
                <span translate>LBL.LOCATION_HISTORY</span>
                <button type="button" class="close" (click)="closeLocationHistory()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div
                class="floating-panel flex-fill"
                [hidden]="!Model.LocationId && !Model.RequestedByGuestId && SaveModel.length == 0"
            >
                <div class="colTabs">
                    <div class="tab_header">
                        <ul class="nav nav-tabs">
                            <li
                                class="nav-item"
                                *ngIf="SaveModel != null && SaveModel.length > 0"
                            >
                                <a
                                    class="nav-link"
                                    [ngClass]="{'active': tabID == 3}"
                                    (click)="tabID = 3"
                                    ><span translate>LBL.MULTI_JOBS</span></a
                                >
                            </li>
                            <li class="nav-item" *ngIf="Model.LocationId">
                                <a
                                    class="nav-link"
                                    [ngClass]="{'active': tabID == 1}"
                                    (click)="tabID = 1"
                                >
                                    <span translate>LBL.LOCATION_HISTORY</span>
                                </a>
                            </li>
                            <li
                                class="nav-item"
                                *ngIf="Model.RequestedByGuestId && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.FrontOffice)"
                            >
                                <a
                                    class="nav-link"
                                    [ngClass]="{'active': tabID == 2}"
                                    (click)="tabID = 2"
                                    ><span translate>LBL.GUEST_DETAILS</span></a
                                >
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content" [hidden]="DisplayMode == 2">
                        <JobConsole_Compact
                            #jobConsole_Compact
                            [hidden]="!Model.LocationId || tabID != 1"
                            [Mode]="_JobSearch_Compact_Mode.Location"
                        ></JobConsole_Compact>
                        <!--<PendingCalls #pendingcalls [hidden]="!Model.LocationId || tabID != 1" [LocationId]="Model.LocationId"></PendingCalls>-->
                        <GuestDetail
                            #guest
                            [hidden]="!Model.RequestedByGuestId || tabID != 2"
                            (onGuestLoaded)="onGuestLoaded($event)"
                            (onPreferenceLoaded)="onPreferenceLoaded($event)"
                            (onPreferenceDeleted)="HighlightPrefIcon()"
                        ></GuestDetail>
                        <div
                            [hidden]="SaveModel == null || SaveModel.length == 0 || tabID != 3"
                        >
                            <table class="table table-sm table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>
                                            <span translate>LBL.DESCR</span>
                                        </th>
                                        <th>
                                            <span translate>LBL.LOCATION</span>
                                        </th>
                                        <th class="text-center">
                                            <span
                                                title="{{'TITLE.TITLE_ATTACHMENTS' | translate}}"
                                            >
                                                <i class="fas fa-paperclip"></i>
                                            </span>
                                        </th>
                                        <th class="text-center">
                                            <span
                                                title="{{'TITLE.TITLE_GUESTS' | translate}}"
                                            >
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </th>
                                        <th>
                                            <span translate>LBL.PRIORITY</span>
                                        </th>
                                        <th>
                                            <span translate
                                                >LBL.ASSIGNMENT</span
                                            >
                                        </th>
                                        <th>
                                            <span translate>LBL.REMARKS</span>
                                        </th>
                                        <th>&nbsp;</th>
                                    </tr>
                                    <tr
                                        *ngFor="let row of SaveModel; let idx = index"
                                    >
                                        <td>{{idx + 1}}</td>
                                        <td>{{row.CallDescriptions}}</td>
                                        <td>{{row.LocationName}}</td>
                                        <td class="text-center">
                                            <span
                                                *ngIf="row.Attachments && row.Attachments.length > 0"
                                                title="{{'TITLE.TITLE_ATTACHMENTS' | translate}} - {{row.Attachments.length}}"
                                            >
                                                <i class="fas fa-paperclip"></i>
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <span
                                                *ngIf="row.RequestedByGuestId"
                                                title="{{'TITLE.TITLE_GUESTS' | translate}}"
                                            >
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </td>
                                        <td>{{row.PriorityText}}</td>
                                        <td>
                                            {{row.IsAutoAssign ? 'Auto':
                                            row.AssignedToName}}
                                        </td>
                                        <td class="linebreak">
                                            {{row.Remarks}}
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-link"
                                                (click)="onCallDelete(idx)"
                                                title="Delete"
                                            >
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ManualAssign
    #manualAssign
    (SelectedStaffChanged)="onAssignedToChanged($event)"
></ManualAssign>
<CallAttachment
    #callAttachment
    (AttachmentChanged)="onAttachmentChanged($event)"
></CallAttachment>
<RecurrenceUpdate
    #recurrenceUpdate
    (RecurrenceAdded)="onClear()"
></RecurrenceUpdate>

<ng-template #confirm let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_CONFIRMATION</h6>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid" *ngIf="ConfirmModel">
        <div class="form-group">
            <div
                *ngFor="let row of ConfirmModel;let i = index"
                class="row pointer"
                [ngClass]="{'border-bottom mb-2 pb-2': (ConfirmModel.length>1 && (i != ConfirmModel.length -1))}"
                (click)="OpenWindow('/Pages/ComplaintPrint?ComplainID='+row.ComplainId)"
            >
                <div class="col-1 text-center">
                    <div
                        class="statusIcon-{{row.CurrentStatus}}"
                        title="{{'TITLE.TITLE_CALLSTATUS_'+row.CurrentStatus | translate}}"
                    >
                        <i class="fas fa-circle"></i>
                    </div>
                </div>
                <div
                    class="col-1 pl-0 pr-0 entryIcon text-center"
                    title="{{'TITLE.TITLE_CALL_NO' | translate}}"
                >
                    {{row.DisplayCallNo}}
                </div>
                <div class="col-3 pr-0 grdCol">
                    <div class="ellipsis mb-1" title="{{row.LocationName}}">
                        <i class="fas fa-map-marker-alt"></i
                        >&nbsp;{{row.LocationName}}
                    </div>
                    <div
                        [hidden]="!row.RequestedByGuestId"
                        class="ellipsis text-muted"
                        title="{{('TITLE.TITLE_GUEST_NAME' | translate) + ' - '+ row.RequestedByGuestName}}"
                    >
                        <span
                            class=""
                            [ngClass]="{'ic-status active': row.Vip}"
                        >
                            <i class="fas fa-briefcase"></i>
                        </span>
                        {{row.RequestedByGuestName}}
                    </div>
                </div>
                <div class="col-3 pr-0 grdCol">
                    <div class="ellipsis mb-1">
                        <span
                            class="fa-fw"
                            [hidden]="row.NoOfAttachments == 0 || row.NoOfAttachments == null"
                            title="{{row.NoOfAttachments > 0 ? (('TITLE.TITLE_ATTACHMENTS' | translate) + ' - ' + row.NoOfAttachments) : ('TITLE.TITLE_NO_ATTACHMENTS' | translate)}}"
                            ><i class="fas fa-paperclip"></i>&nbsp;</span
                        >
                        <span title="{{row.CallDescription}}"
                            >{{row.CallDescription}}</span
                        >
                    </div>
                    <div
                        *ngIf="row.AssignedTo > 0"
                        class="ellipsis text-muted"
                        title="{{('TITLE.TITLE_ASSIGNED_STAFF' | translate) + ' - ' + row.AssignToName}}"
                    >
                        {{row.AssignToName}}
                    </div>
                    <div
                        *ngIf="row.AssignedTo == null"
                        class="text-muted text-danger"
                        title="{{'TITLE.TITLE_UNASSIGNED' | translate}}"
                    >
                        &nbsp;<span translate>LBL.UNASSIGNED</span>
                    </div>
                </div>
                <div class="col-2 pr-0">
                    <div
                        class="mb-1 text-left"
                        title="{{'TITLE.TITLE_ETA_TEXT' | translate}}"
                    >
                        <i class="fas fa-user-clock"></i>&nbsp;{{
                        row.EstimatedTimeToAttendText ?
                        (row.EstimatedTimeToAttendText | translate) :
                        (row.CurrentStatus == 'CLS' ? '' : ('LBL.UNKNOWN' |
                        translate)) }}
                    </div>
                    <div
                        class="consoleRemarks ellipsis"
                        [hidden]="!row.LastRemarks || row.LastRemarks.length == 0"
                        title="{{row.LastRemarks}}"
                    >
                        <i class="far fa-sticky-note"></i
                        >&nbsp;{{row.LastRemarks}}
                    </div>
                </div>
                <div class="col-2" title="{{'TITLE.TITLE_MRT' | translate}}">
                    <span translate
                        >{{row.MRTText ? row.MRTText : 'LBL.UNKNOWN'}}</span
                    >
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="c('')" translate>
            BTN.BTN_DISMISS
        </button>
    </div>
</ng-template>

<div class="console-inline" *ngIf="DisplayMode == 1">
    <JobPopover
        #jobPopover
        [Selected]="complainService._SelectedJob"
        [Mode]="_JobPopoverMode.ReadOnly"
    ></JobPopover>
</div>

<div class="console-inline" *ngIf="DisplayMode == 1">
    <GlitchPopover
        #glitchPopover
        [Selected]="glitchService._SelectedGlitch"
        [Mode]="_JobPopoverMode.ReadOnly"
    ></GlitchPopover>
</div>
